import React from 'react';
import Container from "@mui/material/Container";
import CustomMarkdown from "../components/customMarkdown/CustomMarkdown";

function Privacy() {
    return (
        <Container maxWidth="md" sx={{p:6}}>
            <CustomMarkdown children={['legal.privacy']}/>
        </Container>
    );
}

export default Privacy;
